import SaveIcon from '@mui/icons-material/SaveRounded';
import CloseIcon from '@mui/icons-material/CloseRounded';
import { Button, Modal, Col, Row, Spinner } from "react-bootstrap";
import _ from "lodash";
import { useForm, Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

const AddFaqModal = (
  { phone, setValue, setPhone }
) => {

  const handleClose = () => {
    setPhone(prev => ({ ...prev, showPhoneModal: false }))
  }

  const { handleSubmit, control, formState: { isSubmitting } } = useForm({
    defaultValues: {
      type: 1,
      title: phone.selectedPhone?.title || undefined,
      phone: phone.selectedPhone?.phone || undefined
    }
  });

  const onSubmit =
    async (data) => {
      try {
        if (_.isEmpty(phone.selectedPhone)) {
          setPhone(prev => {
            setValue("phones", [...prev.phones, {
              title: data.title,
              phone: data.phone
            }])
            return {
              ...prev, phones: [...phone.phones, {
                title: data.title,
                phone: data.phone
              }]
            }
          })
        } else {
          const updatedPhones = phone.phones?.map((item, index) => {
            if (phone.selectedPhoneId == index) {
              return {
                title: data.title,
                phone: data.phone
              }
            } else {
              return item
            }
          })
          setPhone(prev => ({ ...prev, phones: [...updatedPhones] }))
          setValue("phones", [...updatedPhones])
        }
        handleClose()
      } catch (error) {
      }
    }

  return (
    <div>
      <div className="card-body pt-3 pb-0">
        {/* Start Modal */}
        <Modal centered onHide={handleClose} show={phone.showPhoneModal} >
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">ایجاد تلفن و عنوان جدید</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs='12'>
                <Row>
                  <Col xs='12'>
                    <Controller
                      name="title"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="عنوان"
                          className="mt-5"
                          variant="outlined"
                          margin="normal"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>
                  <Col xs='12' className="my-5">
                    <Controller
                      name="phone"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="تلفن"
                          className="mt-5"
                          variant="outlined"
                          margin="normal"
                          size="small"
                          value={value || ""}
                          onInput={onChange}
                        />
                      )}
                    />
                  </Col>
                </Row>
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon />  ذخیره
                </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon />  بستن
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    </div >
  );
}

export default AddFaqModal;

